import { autoinject } from "aurelia-framework";
import { DialogClientService } from "@rightship-tech/common-ui/services/basic/dialog-client.service";

@autoinject
export class RightShipInspectionBadgeExampleDialog {
    
    constructor (private dialogClientService: DialogClientService){

    }

    close() {
        this.dialogClientService.hide();
    }
}